import React, { useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import { Paper, Box, Button, Typography, TextField, Divider, Table, TableHead, TableBody, TableCell, TableRow, Autocomplete } from '@mui/material';
import { ApolloClient, ApolloProvider, gql, InMemoryCache, useMutation, useQuery } from "@apollo/client";
import { Modal } from "./modal";
import { GitGraph } from "./git-graph";
import { Background, ReactFlow, useEdgesState, useNodesState, useReactFlow } from '@xyflow/react'
import { DndContext } from '@dnd-kit/core'
import '@xyflow/react/dist/style.css';
import { nanoid } from "nanoid";
import { SidebarElement } from "./sidebar/element";
import { EditorWindow } from "./editor";

const client = new ApolloClient({
  uri: localStorage.getItem('HEXHIVE_API') || 'http://localhost:7030/graphql',
  credentials: 'include',
  cache: new InMemoryCache()
})

export default function Root(props){
  return (
    <ApolloProvider client={client}>
      <RootWrapped {...props} />
    </ApolloProvider>
  )
}

function RootWrapped(props) {

  const flow = useReactFlow();
  const [ nodes, setNodes, onNodesChanged ] = useNodesState([{id: nanoid(), position: {x: 100, y: 200}, data: {label: "Entry"}}]);
  const [ edges, setEdges, onEdgesChanged] = useEdgesState([]);

  const handleDragEnd = (info) => {
    console.log("Drag end", info)
    if(info.over.id == 'editor-window'){
      //Do something with the event
      info.active.id;
      info.delta;
      setNodes((nodes) => {
        let n = nodes.slice();
        n.push({id: nanoid(), position: flow.screenToFlowPosition({x: info.delta.x, y: info.delta.y}), data: {label: info.active.id}})
        return n;
      })
    }
  }

    return (
      <DndContext onDragEnd={handleDragEnd}>
      <div style={{
        display: 'flex',
        flex: 1
      }}>
        <div style={{width: '200px'}}>
          <Typography fontWeight={"bold"}>Components</Typography>
          <Divider sx={{marginTop: '8px', marginBottom: '8px'}}/>
          <Typography>Triggers</Typography>
          <Divider />
          <div>
            {props.triggers?.map((trigger, ix) => (
              <SidebarElement key={`trig-${trigger.id}`} id={trigger.id} name={trigger.name} />
            ))}
          </div>
          <Typography>Actions</Typography>
          <Divider />
          <div>
            {props.actions?.map((action, ix) => (
              <SidebarElement key={`action-${action.id}`} id={action.id} name={action.name} />
            ))}
          </div>
        </div>
        <Divider orientation="vertical"/>
        <EditorWindow
          nodes={nodes}
          edges={edges}
          />
      </div>
      </DndContext>
    )
}


/*
commit id: "1"
       commit id: "2"
       branch nice_feature
       checkout nice_feature
       commit id: "3"
       checkout main
       commit id: "4"
       checkout nice_feature
       branch very_nice_feature
       checkout very_nice_feature
       commit id: "5"
       checkout main
       commit id: "6"
       checkout nice_feature
       commit id: "7"
       checkout main
       merge nice_feature id: "customID" tag: "customTag" type: REVERSE
       checkout very_nice_feature
       commit id: "8"
       checkout main
       commit id: "9"
*/
